import { Fragment, ReactElement } from 'react'
import styled from 'styled-components'

import { theme } from '@/styles/theme'

import { evaluationItems } from './evaluationItems'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/enlayout'
import { Head } from '@/components/enlayouts/Head'
import { Layout } from '@/components/enlayouts/Ir'
interface TitleProps {
  isLast?: boolean;
}
export const EvaluationPage = () => {
  return (
    <Layout>
      <SectionTitle
        color="normal"
        titleText="Evaluation"
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <OfficerList>
        {evaluationItems.map(({ title, imgPath, url, profile }, index) => (
          <Fragment key={imgPath}>
            {index > 0 && <Spacer h={{ sp: 30, pc: 40 }} />}
            <OfficerItem>
              <PersonalInfo>
                <Title isLast={index === evaluationItems.length - 1 || index === evaluationItems.length - 2}>{title}</Title>
                <a
                  href={index === evaluationItems.length - 1 || index === evaluationItems.length - 2 ? url : undefined}
                  target={index === evaluationItems.length - 1 || index === evaluationItems.length - 2 ? '_blank' : undefined}
                  rel="noopener noreferrer"
                  className={index === evaluationItems.length - 1 || index === evaluationItems.length - 2 ? 'pdf_after' : undefined}
                  style={{cursor: "default"}}
                >
                  <Images src={imgPath} isLast={index === evaluationItems.length - 1 || index === evaluationItems.length - 2} />
                </a>
              </PersonalInfo>
              <Profile>
                {profile.map(({ date, content }, index, array) => (
                  <Fragment key={date}>
                    <ProfileItem>
                      <p>{date}</p>
                      <p>{content}</p>
                    </ProfileItem>
                    {index < array.length - 1 && (
                      <Spacer h={{ sp: 10, pc: 12 }} />
                    )}
                  </Fragment>
                ))}
              </Profile>
            </OfficerItem>
            <SpacerBorder h={{ sp: 30, pc: 40 }} />
          </Fragment>
        ))}
      </OfficerList>
    </Layout>
  )
}

EvaluationPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'Home', path: '/en' },
    { name: 'Investor Relations', path: '/en/ir' },
    { name: 'Evaluation', path: '' },
  ]

  return (
    <>
      <Head
        title="Evaluation"
        description="トライアルホールディングスのIRメール配信のお申し込み方法、停止方法について掲載しています。"
        ogp={{ url: 'en/ir/evaluation' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle="Investor Relations"
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}

const OfficerList = styled.ul`
  width: 100%;
`

const OfficerItem = styled.div`
  display: flex;
  gap: 37px;
  @media screen and (max-width: 1047px) {
    gap: 20px;
  }
  @media screen and (max-width: 500px) {
    flex-direction: column;
  }
`

const SpacerBorder = styled(Spacer)`
  :not(:last-of-type) {
    border-bottom: 1px solid ${theme.colors.grey};
  }
`

const PersonalInfo = styled.div<TitleProps>`
  width: 210px;
  text-align: center;

  @media screen and (max-width: 1047px) {
    width: 180px;
  }
  @media screen and (max-width: 500px) {
    width: 100%;
  }

  a.pdf_after {
    display: inline-block;
    position: relative;
    cursor: pointer !important;
  }

  a.pdf_after::after {
    content: '';
    width: 12px;
    height: 12px;
    margin-left: 8px;
    display: inline-block;
    background: url('/images/external-link-black.svg') no-repeat;
    background-size: contain;
    vertical-align: middle;
  }

  a.pdf_after:hover::after {
    background: url('/images/external-link-hoverblue.svg') no-repeat;
    background-size: contain;
  }
`

const Title = styled.p<TitleProps>`
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 1.8px;
  font-weight: bold;
  ${({ isLast }) =>
    isLast &&
    `
      font-size: 15px;
    `}

  @media screen and (max-width: 500px) {
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 1.6px;
  }
`

const Images = styled.img<{ isLast?: boolean }>`
  width: ${({ isLast }) => (isLast ? '190px' : '130px')};
  margin-top: 20px;
  @media screen and (max-width: 500px) {
    width: ${({ isLast }) => (isLast ? '70%' : '60%')};
  }
`

const Profile = styled.div`
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 1.6px;
  flex: 1;
  width: calc(100% - 247px);

  @media screen and (max-width: 1047px) {
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 1.4px;
    width: calc(100% - 200px);
  }
  @media screen and (max-width: 500px) {
    width: 100%;
    margin-top: 15px;
  }
`

const ProfileItem = styled.li`
  // display: flex;
  // gap: 20px;

  p:first-child {
    font-weight: bold;
  }

  p:last-child {
    margin-top: 15px;
  }

  @media screen and (max-width: 1047px) {
    // gap: 10px;

    // p::first-child {
    //   width: 90px;
    // }
  }
`
